const constants = {
  JPAS_UPDATE_USERS_PENDING: 'JPAS_UPDATE_USERS_PENDING',
  JPAS_UPDATE_USERS_SUCCESS: 'JPAS_UPDATE_USERS_SUCCESS',
  JPAS_GET_USERS_PENDING: 'JPAS_GET_USERS_PENDING',
  JPAS_GET_USERS_SUCCESS: 'JPAS_GET_USERS_SUCCESS',
  JPAS_REFRESH_PENDING: 'JPAS_REFRESH_PENDING',
  JPAS_REFRESH_SUCCESS: 'JPAS_REFRESH_SUCCESS',
  JPAS_UPLOAD_PENDING: 'JPAS_UPLOAD_PENDING',
  JPAS_UPLOAD_SUCCESS: 'JPAS_UPLOAD_SUCCESS',
  JPAS_CURRENT_JOB_PENDING: 'JPAS_CURRENT_JOB_PENDING',
  JPAS_CURRENT_JOB_SUCCESS: 'JPAS_CURRENT_JOB_SUCCESS',
  JPAS_JOB_STATUS_PENDING: 'JPAS_JOB_STATUS_PENDING',
  JPAS_JOB_STATUS_SUCCESS: 'JPAS_JOB_STATUS_SUCCESS',
};

export default constants;
